import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './UserOrderPage.module.scss';
import clsx from 'clsx';
import { useParams } from 'react-router';
import { userFindTransaction } from '../../redux/actions/user/userFindTransaction';
import Loading from '../../components/Loading/Loading';
import LoginForm from '../../components/LoginForm/LoginForm';
import Block from '../../components/Block/Block';
import NotFound from '../../components/NotFound/NotFound';
import { ToastContainer } from 'react-toastify';
import OrderContent, { sendMessageToParent } from '../../components/OrderContent/OrderContent';
import Button from '../../components/Button/Button';
const UserOrderPage = () => {
  const { transactionId } = useParams();
  const [page, setPage] = useState();
  const dispatch = useDispatch();
  const {
    userFindTransaction: { data: userFindTransactionData, loading: userFindTransactionLoading, error: userFindTransactionError },
  } = useSelector((state) => state.user);

  const {
    userLogin: { data: userLoginData, loading: userLoginLoading, error: userLoginError },
  } = useSelector((state) => state.user);
  useEffect(() => {
    if (transactionId) {
      dispatch(userFindTransaction(transactionId));
    }
  }, [transactionId]);
  useEffect(() => {
    if (userFindTransactionData) {
      if (userFindTransactionData?.status == 'ERROR_PARTNER_CREATED' && !userFindTransactionData?.children?.length) {
        setPage('NOT_VALID');
      } else {
        setPage('ORDER');
      }
    }
  }, [userFindTransactionData]);
  useEffect(() => {
    if (userLoginData) {
      dispatch(userFindTransaction(transactionId));
    }
  }, [userLoginData]);

  useEffect(() => {
    if (userFindTransactionError) {
      if (userFindTransactionError?.statusCode == 404) {
        setPage('NOT_FOUND');
      }
      if (userFindTransactionError?.statusCode == 401) {
        setPage('AUTH');
      }
    }
  }, [userFindTransactionError]);
  const getContent = () => {
    switch (page) {
      case 'NOT_FOUND':
        return <NotFound title="Заказ не найден" text="Проверьте ссылку или попробуйте еще раз" />;
      case 'NOT_VALID':
        return (
          <NotFound
            title="Данные игры не поддерживают скидку"
            text="Добавить другие игры и попробуйте снова"
            button={
              <Button
                type="success"
                className={clsx(styles.btnClose)}
                onClick={() => {
                  sendMessageToParent('gamiPass:error', {
                    reason: 'ERROR_USER',
                  });
                }}>
                Закрыть
              </Button>
            }
            icon={
              <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 36 36" style={{ marginBottom: '20px' }}>
                <defs>
                  <linearGradient id="a" x1="13.9%" x2="86.1%" y1="100%" y2="0%">
                    <stop offset="0%" stop-color="#33b1ee" />
                    <stop offset="79.68%" stop-color="var(--theme-default)" />
                  </linearGradient>
                </defs>
                <circle cx="18" cy="18" r="16" fill="url(#a)" />
                <path fill="#fff" d="M27 14.28a1.8 1.8 0 1 1-1.8-1.8 1.8 1.8 0 0 1 1.8 1.8m-15.55 1.8a1.8 1.8 0 1 1 1.8-1.8 1.8 1.8 0 0 1-1.84 1.8Zm14 7.53a1 1 0 0 1-1.6 1.2 7 7 0 0 0-11.31.13 1 1 0 1 1-1.63-1.16 9 9 0 0 1 14.54-.17" />
              </svg>
            }
          />
        );
      case 'AUTH':
        return (
          <>
            <img src="/img/logo.png" alt="" className={clsx(styles.logo)} />
            <Block className={clsx(styles.block)}>
              <LoginForm isPage className={clsx(styles.login)} type={'USER'} />
            </Block>
          </>
        );
      case 'ORDER':
        return <OrderContent {...userFindTransactionData} />;

      default:
        break;
    }
  };
  return (
    <>
      <div className={clsx(styles.wrap)}>
        <ToastContainer theme="colored" />
        {userFindTransactionLoading ? <Loading className={clsx(styles.loading)} /> : getContent()}
        {/* {userFindTransactionLoading ? (
          <Loading className={clsx(styles.loading)} />
        ) : (
          <>
            <img src="/img/logo.png" alt="" className={clsx(styles.logo)} />
            <Block className={clsx(styles.block)}>
              <LoginForm isPage className={clsx(styles.login)} type={'USER'} />
            </Block>
          </>
        )} */}
      </div>
    </>
  );
};

export default UserOrderPage;
